module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0143.jpg?v=dc982a4d";